import { render, staticRenderFns } from "./RbacRoleUsersDialog.vue?vue&type=template&id=776a3aec"
import script from "./RbacRoleUsersDialog.vue?vue&type=script&lang=js"
export * from "./RbacRoleUsersDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports